@let stats = analytics();
@let attempts = allAttempts();

<!-- @if (isLoading()) {
<div class="flex flex-col gap-4 w-full mt-6">
    <div class="animate-pulse h-32 w-full bg-gray-200 rounded-xl"></div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="animate-pulse h-64 bg-gray-200 rounded-xl"></div>
        <div class="animate-pulse h-64 bg-gray-200 rounded-xl"></div>
        <div class="animate-pulse h-64 bg-gray-200 rounded-xl"></div>
    </div>
</div> -->
@if (!stats || stats.totalAttempts === 0) {
<!-- Empty State -->
<div class="flex flex-col items-center justify-center py-16 bg-white border border-slate-200 rounded-xl shadow-sm mt-6">
    <div class="flex items-center justify-center w-16 h-16 rounded-full bg-slate-50 text-slate-400 text-3xl mb-4">
        <i class="fas fa-chart-bar"></i>
    </div>
    <h3 class="text-lg font-bold text-slate-700 m-0">No Analytics Available</h3>
    <p class="text-sm text-slate-400 mt-1 max-w-sm text-center">
        Analytics will be compiled once the quiz is closed and marked as completed by faculty or management.
    </p>
    @if (showReRunButton) {
    <button (click)="reRunAnalytics()" [disabled]="isWorking() || isLoading()"
        class="mt-4 px-4 py-2 text-xs font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all shadow-sm">
        @if (isWorking()) {
        <span class="inline-flex items-center gap-1.5">
            <i class="fas fa-spinner animate-spin"></i> Compiling...
        </span>
        } @else {
        <span>Run Analytics</span>
        }
    </button>
    }
</div>
} @else {
<!-- Symmetrically Balanced Bento-Grid Layout -->
<div class="flex flex-row flex-wrap gap-4 mt-4">

    <!-- TILE 3: Leaderboard (Top 5 Attempts) -->
    <div
        class="bg-white {{ isLoading() ? 'animate-pulse' : 'p-4' }} rounded-xl border border-slate-200 shadow-sm flex flex-col flex-1">
        <h3 class="text-sm font-bold text-slate-800 mb-3 flex items-center gap-3">
            <colored-icon iconClass="fas fa-trophy" bgColorClass="bg-amber-100"
                textColorClass="text-amber-600"></colored-icon>
            <span>Leaderboard - Top 5 Performers</span>
        </h3>
        <div class="flex-1 overflow-x-auto">
            <table class="w-full text-left border-collapse">
                <thead>
                    <tr class="border-b border-slate-100">
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider w-12 text-center">
                            Rank</th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider">Participant</th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider text-right">Score
                        </th>
                        <!-- <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider text-right">Time
                            Taken</th> -->
                    </tr>
                </thead>
                <tbody>
                    @for (att of stats.topAttempts; track att.userId; let i = $index) {
                    <tr class="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                        <td class="py-2 text-center">
                            @if (i === 0) {
                            <span
                                class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-100 text-amber-600 font-bold text-xs">1</span>
                            } @else if (i === 1) {
                            <span
                                class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-slate-100 text-slate-600 font-bold text-xs">2</span>
                            } @else if (i === 2) {
                            <span
                                class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-orange-100 text-orange-600 font-bold text-xs">3</span>
                            } @else {
                            <span class="text-slate-500 font-bold text-xs">{{ i + 1 }}</span>
                            }
                        </td>
                        <td class="py-2">
                            <div class="flex items-center gap-2">
                                @if (att.userPhotoUrl) {
                                <img [src]="att.userPhotoUrl" alt=""
                                    class="w-6 h-6 rounded-full border border-slate-100">
                                } @else {
                                <div
                                    class="w-6 h-6 rounded-full bg-slate-100 border border-slate-200 text-slate-500 flex items-center justify-center font-bold text-[10px]">
                                    {{ (att.userName || '').substring(0, 2) | uppercase }}
                                </div>
                                }
                                <span class="font-semibold text-slate-700 text-xs">{{ att.userName }}</span>
                            </div>
                        </td>
                        <td class="py-2 text-right font-bold text-emerald-600 text-xs">
                            {{ att.userScore }} <span class="text-[10px] font-normal text-slate-400">/ {{
                                parent.quiz?.totalScore }}</span>
                        </td>
                        <!-- <td class="py-2 text-right text-slate-500 text-xs font-mono">
                            {{ formatDuration(att.timeTaken) }}
                        </td> -->
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    <!-- LEFT COLUMN: Combined KPIs & Score Distribution -->
    <div class="flex flex-col gap-4 flex-1">

        <!-- TILE 1: Combined KPI Card (attempts, avg score, avg duration in one column) -->
        <div class="flex flex-row gap-4 flex-1">

            <!-- KPI Element 1: Total Attempts -->
            <div class="flex flex-col justify-between bg-white rounded-xl border border-slate-200 shadow-sm p-2 flex-1">
                <div class="flex items-center gap-3 mb-1.5">
                    <colored-icon iconClass="fas fa-user-check" bgColorClass="bg-indigo-100"
                        textColorClass="text-indigo-600"></colored-icon>
                    <span class="text-sm font-medium text-slate-800 tracking-wider">Total Attempts</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-2xl font-bold text-slate-900 text-right w-full">{{ stats.totalAttempts }}</span>
                    <span class="text-xs text-blueGray-400 mt-0.5 text-right w-full">Completed</span>
                </div>
            </div>

            <!-- KPI Element 2: Average Score -->
            <div class="flex flex-col justify-between bg-white rounded-xl border border-slate-200 shadow-sm p-2 flex-1">
                <div class="flex items-center gap-3 mb-1.5">
                    <colored-icon iconClass="fas fa-percentage" bgColorClass="bg-emerald-100"
                        textColorClass="text-emerald-600"></colored-icon>
                    <span class="text-sm font-medium text-slate-800 tracking-wider">Average Score</span>
                </div>
                <div class="flex flex-col">
                    <span class="text-2xl font-bold text-slate-900 text-right w-full">
                        {{ stats.averageScore | number: '1.1-1' }}
                        <span class="text-sm font-normal text-slate-400">/ {{ parent.quiz?.totalScore }}</span>
                    </span>
                    <span class="text-xs text-blueGray-400 mt-0.5 text-right w-full">
                        Class avg: {{ (stats.averageScore / (parent.quiz?.totalScore || 1) * 100) | number: '1.0-0' }}%
                    </span>
                </div>
            </div>

        </div>

        <!-- TILE 2: Score Distribution -->
        <div class="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between">
            <h3 class="text-sm font-bold text-slate-800 mb-3 flex items-center gap-3">
                <colored-icon iconClass="fas fa-chart-pie" bgColorClass="bg-indigo-100"
                    textColorClass="text-indigo-600"></colored-icon>
                <span>Score Distribution</span>
            </h3>
            <div class="flex flex-col gap-2.5 flex-1 justify-center">
                @for (bracket of ['81-100%', '61-80%', '41-60%', '21-40%', '0-20%']; track bracket) {
                @let count = stats.scoreDistribution[bracket] || 0;
                @let percent = stats.totalAttempts > 0 ? (count / stats.totalAttempts * 100) : 0;
                <div class="flex flex-col gap-1">
                    <div class="flex items-center justify-between text-[11px] font-semibold">
                        <span class="text-slate-600">{{ bracket }}</span>
                        <span class="text-slate-500 font-mono">{{ count }} ({{ percent | number: '1.0-0' }}%)</span>
                    </div>
                    <div class="w-full bg-slate-100 h-1.5 rounded-full overflow-hidden">
                        <div class="bg-indigo-500 h-full rounded-full transition-all duration-300"
                            [style.width.%]="percent"></div>
                    </div>
                </div>
                }
            </div>
        </div>

    </div>

    <!-- TILE 4: Troubled Questions (Wrongly Answered) -->
    <div class="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col flex-1">
        <h3 class="text-sm font-bold text-slate-800 mb-1.5 flex items-center gap-3">
            <colored-icon iconClass="fas fa-exclamation-triangle" bgColorClass="bg-red-100"
                textColorClass="text-red-600"></colored-icon>
            <span>Hardest Questions (Wrongly Answered)</span>
        </h3>
        <p class="text-[11px] text-slate-400 m-0 mb-3">Questions most frequently answered incorrectly</p>
        <div class="flex flex-col gap-2 flex-1">
            @if (!stats.mostWrongQuestions || stats.mostWrongQuestions.length === 0) {
            <div class="text-xs text-slate-400 italic py-4 text-center">No questions answered incorrectly. Great
                job class!</div>
            } @else {
            @for (q of stats.mostWrongQuestions; track q.questionId; let i = $index) {
            <div
                class="flex items-start gap-2.5 p-2 bg-red-50/30 border border-red-100 rounded-xl hover:bg-red-50/50 transition-colors">
                <span
                    class="flex items-center justify-center w-5 h-5 rounded-full bg-red-100 text-red-600 font-bold text-xs mt-0.5">{{
                    i + 1 }}</span>
                <div class="flex flex-col flex-1 gap-0.5">
                    <span class="text-xs font-semibold text-slate-800 line-clamp-1">{{ q.questionText }}</span>
                    <div class="flex items-center gap-2 text-[10px] text-slate-400">
                        <span>Correct: {{ q.correctCount }}</span>
                        <span>•</span>
                        <span class="text-red-500 font-semibold">{{ q.wrongCount }} wrong</span>
                    </div>
                </div>
            </div>
            }
            }
        </div>
    </div>


</div>

<div class="flex flex-row w-full flex-wrap gap-4 mt-4">

    <!-- Bible Mastery Chart -->
    <div
        class="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col flex-1 w-full max-w-full overflow-hidden">
        <h3 class="text-sm font-bold text-slate-800 mb-3 flex items-center gap-3">
            <colored-icon iconClass="fas fa-book" bgColorClass="bg-indigo-100"
                textColorClass="text-indigo-600"></colored-icon>
            <span>Mastery by Bible Reference</span>
        </h3>
        <div class="h-64 w-full relative">
            @if (bibleBookMasteryChartData()) {
            <canvas baseChart [data]="bibleBookMasteryChartData()!" [options]="barOptions" [type]="'bar'">
            </canvas>
            } @else {
            <div class="flex items-center justify-center w-full h-full">
                <span class="text-xs text-slate-400 italic">No Bible reference data found.</span>
            </div>
            }
        </div>
    </div>

    <!-- Difficulty Bubble Chart -->
    <div
        class="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col flex-1 w-full max-w-full overflow-hidden">
        <h3 class="text-sm font-bold text-slate-800 mb-3 flex items-center gap-3">
            <colored-icon iconClass="fas fa-bullseye" bgColorClass="bg-rose-100"
                textColorClass="text-rose-600"></colored-icon>
            <span>Question Difficulty vs. Bible Reference</span>
        </h3>
        <div class="h-64 w-full relative">
            @if (difficultyBubbleChartData()) {
            <canvas baseChart [data]="difficultyBubbleChartData()!" [options]="bubbleOptions" [type]="'bubble'">
            </canvas>
            } @else {
            <div class="flex items-center justify-center w-full h-full">
                <span class="text-xs text-slate-400 italic">No question metrics data found.</span>
            </div>
            }
        </div>
    </div>

</div>

<!-- Student Performance Matrix Table -->
<div class="flex flex-row w-full mt-4">
    <div
        class="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col flex-1 w-full max-w-full overflow-hidden">
        <h3 class="text-sm font-bold text-slate-800 mb-1.5 flex items-center gap-3">
            <colored-icon iconClass="fas fa-table" bgColorClass="bg-emerald-100"
                textColorClass="text-emerald-600"></colored-icon>
            <span>Student Performance Matrix</span>
        </h3>
        <p class="text-[11px] text-slate-400 m-0 mb-3">Response matrix showing correct (✓), incorrect (✗), or unanswered
            (-) answers per student per question.</p>

        @if (stats.matrix && stats.matrix.students && stats.matrix.students.length > 0) {
        <div class="overflow-x-auto w-full max-w-full max-h-[500px]">
            <table class="w-full text-left border-collapse min-w-full">
                <thead>
                    <tr class="border-b border-slate-100 bg-slate-50">
                        <th
                            class="py-2.5 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider sticky top-0 left-0 bg-slate-50 z-30 shadow-[2px_2px_5px_-2px_rgba(0,0,0,0.1)] w-64 min-w-[180px] sm:min-w-[280px]">
                            Question Reference & Text</th>
                        @for (student of stats.matrix.students; track student.userId) {
                        <th
                            class="py-2.5 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-center min-w-[80px] sm:min-w-[100px] md:min-w-[120px] sticky top-0 bg-slate-50 z-20 border-b border-slate-100">
                            <div
                                class="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-1.5 text-center">
                                @if (getStudentPhotoUrl(student.userId)) {
                                <img [src]="getStudentPhotoUrl(student.userId)" alt=""
                                    class="w-5 h-5 rounded-full border border-slate-100">
                                } @else {
                                <div
                                    class="w-5 h-5 rounded-full bg-slate-100 border border-slate-200 text-slate-500 flex items-center justify-center font-bold text-[9px] uppercase">
                                    {{ (student.userName || '').substring(0, 2) }}
                                </div>
                                }
                                <span class="break-words max-w-[80px] sm:max-w-none">{{ student.userName | titlecase
                                    }}</span>
                            </div>
                        </th>
                        }
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    @for (q of stats.matrix.questions; track q.questionId; let i = $index) {
                    @let qMeta = stats.questionStats[i];
                    <tr class="hover:bg-slate-50/50 transition-colors">
                        <td class="py-2.5 px-3 sticky left-0 bg-white shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] z-10">
                            <div class="flex flex-col">
                                <span class="text-[10px] font-bold text-indigo-600 uppercase">
                                    Q{{ i + 1 }} @if (qMeta?.book) { • {{ qMeta.book }} {{ qMeta.chapter }}:{{
                                    qMeta.verse }} }
                                </span>
                                <span class="text-xs text-slate-700 font-medium line-clamp-2 mt-0.5"
                                    [title]="q.questionText">
                                    {{ q.questionText }}
                                </span>
                            </div>
                        </td>
                        @for (student of stats.matrix.students; track student.userId) {
                        @let cell = stats.matrix.grid[q.questionId]?.[student.userId];
                        <td class="py-2.5 px-3 text-center">
                            @if (cell?.status === 'correct') {
                            <span
                                class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-emerald-50 text-emerald-600 font-bold text-xs"
                                title="Correct">
                                <i class="fas fa-check"></i>
                            </span>
                            } @else if (cell?.status === 'wrong') {
                            <span
                                class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-rose-50 text-rose-600 font-bold text-xs"
                                title="Incorrect">
                                <i class="fas fa-times"></i>
                            </span>
                            } @else {
                            <span
                                class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-slate-50 text-slate-400 font-semibold text-xs"
                                title="Unanswered / Skipped">
                                -
                            </span>
                            }
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        } @else {
        <div class="text-xs text-slate-400 italic py-8 text-center bg-slate-50 rounded-xl">
            No participant data available to display matrix.
        </div>
        }
    </div>
</div>

@if (!parent.quiz?.isLive) {
<!-- Participant Attempts History -->
<div class="flex flex-row w-full mt-4">

    <div class="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col flex-1">
        <h3 class="text-sm font-bold text-slate-800 mb-3 flex items-center gap-3">
            <colored-icon iconClass="fas fa-history" bgColorClass="bg-slate-100"
                textColorClass="text-slate-600"></colored-icon>
            <span>Full Quiz Attempts History</span>
        </h3>
        <div class="overflow-x-auto w-full">
            <table class="w-full text-left border-collapse min-w-[600px]">
                <thead>
                    <tr class="border-b border-slate-100">
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider">Student</th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider">Date Completed</th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider text-right">Score</th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider text-right">Time Taken
                        </th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider text-center">Status
                        </th>
                        <th class="py-2 text-xs font-bold text-slate-400 uppercase tracking-wider text-center w-28">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (att of attempts; track att.id) {
                    <tr class="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                        <td class="py-2">
                            <div class="flex items-center gap-2.5">
                                @if (att.userPhotoUrl) {
                                <img [src]="att.userPhotoUrl" alt=""
                                    class="w-7 h-7 rounded-full border border-slate-100">
                                } @else {
                                <div
                                    class="w-7 h-7 rounded-full bg-slate-100 border border-slate-200 text-slate-500 flex items-center justify-center font-bold text-xs">
                                    {{ (att.userName || '').substring(0, 2) | uppercase }}
                                </div>
                                }
                                <span class="font-bold text-slate-700 text-xs">{{ att.userName }}</span>
                            </div>
                        </td>
                        <td class="py-2 text-slate-500 text-xs">
                            {{ att.modified | moment : 'Do MMM YYYY, h:mm A' }}
                        </td>
                        <td class="py-2 text-right font-bold text-slate-700 text-xs">
                            {{ att.userScore ?? 0 }} <span class="text-[10px] font-normal text-slate-400">/ {{
                                parent.quiz?.totalScore }}</span>
                        </td>
                        <td class="py-2 text-right text-slate-500 text-xs font-mono">
                            {{ formatDuration(att.timeTaken ?? (att.modified && att.startTime ? (att.modified.seconds -
                            att.startTime.seconds) : 0)) }}
                        </td>
                        <td class="py-2 text-center">
                            <app-chip [label]="(att.completed ? 'completed' : 'in progress') | titlecase"
                                padding="px-1.5 py-0.5" [color]="att.completed ? chipColor.SUCCESS : chipColor.WARNING">
                            </app-chip>
                        </td>
                        <td class="py-2 text-center">
                            <button [routerLink]="['../active']" [queryParams]="{ attemptId: att.id }"
                                [replaceUrl]="true"
                                class="px-2.5 py-1 text-xs font-semibold text-indigo-600 bg-indigo-50 border-0 rounded-lg hover:bg-indigo-100 active:scale-95 transition-all cursor-pointer">
                                View Answers
                            </button>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="6" class="py-8 text-xs text-slate-400 italic text-center">
                            No attempts have been recorded for this quiz.
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

</div>
}

}